import { el, list } from 'redom';

import './index.scss';

class Option {

  constructor(list) {

    this.list = list;
    this.option = null;

    this.el = el('span.menu-option-item', {
      onclick: this.handleClick.bind(this)
    });

  }

  handleClick(event) {

    event.stopPropagation();
    event.preventDefault();

    return this.list.onSelect(event, this.option);

  }

  update(option) {

    this.option = option;

    this.el.textContent = option.label;

  }

}

class OptionsList {

  constructor(configuration) {

    this.options = configuration.options;
    this.onSelect = configuration.onSelect;
    this.ItemView = configuration.ItemView || Option;

    this.list = list('.menu-options-list-main.hide-scrollbar', this.ItemView, null, this);

    this.list.update(this.options);

    this.el = this.list.el;

  }

}

export default OptionsList;